<template>
    <div style="overflow:auto;">
        <div v-if="isLoaded">
            <FindPositionProResult :positions-arr="positions" :show-graph="false" :grouped-data="grouped_data" :is-top-btn-hidden="true"/>
        </div>
    </div>
</template>

<script>
    import ResponseCode from "../../ResponseCode";
    import {FIND_POSITION_PRO_TITLE} from "../../Constants";
    import FindPositionProResult from "./FindPositionProResult";

    export default {
        name: "SharePositionPro",
        components: {FindPositionProResult},
        data(){
            return {
                isLoaded : false,
                positions : [],
                grouped_data : {}

            }
        },
        methods : {
            async getPositionProInfo(){
                const parameters = {};
                parameters.target = this.$route.query.target;

                const res = await this.$Axios.get('/api/share/position/pro', {params : parameters});
                if(res.data.code === ResponseCode.SUCCESS){
                    const ability_arr = res.data.position_pro_ability.split(',');
                    this.grouped_data = {
                        [FIND_POSITION_PRO_TITLE.HEALTH] : ability_arr[0],
                        [FIND_POSITION_PRO_TITLE.EYESIGHT] : ability_arr[1],
                        [FIND_POSITION_PRO_TITLE.MAIN_FORCE] : ability_arr[2],
                        [FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT] : ability_arr[3],
                        [FIND_POSITION_PRO_TITLE.BALL_CONTROL] : ability_arr[4],
                    };

                    this.positions = [{
                        desc : res.data.position,
                        position : res.data.position
                    }];

                    // this.$GlobalStore.addModal('FindPositionProResult', {positionsArr: positions, showGraph: false, groupedData : groupData})

                    this.isLoaded = true;
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        created(){
            this.getPositionProInfo();
        }


    }
</script>

<style scoped>

</style>